<template>
    <div>
        <header-theme :breadcrumb="this.breads"></header-theme>
        <main>
            <div class="row">
                <div class="col s12">
                    <table class="highlight">
                        <thead>
                            <tr>
                                <th>Data</th>
                                <th>Qtd Itens</th>
                                <th>Opções</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="row in rows" :key="row.id">
                                <td>{{ row.data }}</td>
                                <td>{{ row.qtd_itens }}</td>
                                <td>
                                    <a href=""><i class="blue-text text-lighten-1 material-icons">edit</i></a>
                                </td>
                            </tr>
                        </tbody>

                        <tfoot class="grey lighten-3">
                            <tr>
                                <td>Total</td>
                                <td>{{ rows.map(el => el.qtd_itens).reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue)) }}</td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </main>
        <side-menu></side-menu>
    </div>
</template>

<script>
import SideMenu from "../shared/side_menu/SideMenu.vue";
import HeaderTheme from "../shared/header_theme/HeaderTheme.vue";

export default {
    name: "CircularList",
    components: {
        "side-menu": SideMenu,
        "header-theme": HeaderTheme
    },
    mounted() {
        console.log(this.rows.map(el => el.qtd_itens).reduce((accumulator, currentValue) => Number(accumulator) + Number(currentValue)));
    },
    data() {
        return {
            breads: [
                {
                    url: "/",
                    title: "Home"
                },
                {
                    url: "#",
                    title: "Gerar Circular"
                },
            ],
            rows: [
                {
                    id: 1,
                    data: "18/02/2019",
                    qtd_itens: 4
                },
                {
                    id: 2,
                    data: "17/02/2019",
                    qtd_itens: 2
                },
                {
                    id: 3,
                    data: "16/02/2019",
                    qtd_itens: 4
                },
                {
                    id: 4,
                    data: "15/02/2019",
                    qtd_itens: 2
                }
            ]
        }
    }   
}
</script>

<style lang="scss" scoped>
main {
  padding-left: 240px;
}
</style>





// WEBPACK FOOTER //
// src/components/circular_list/CircularList.vue